import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone;
    if (standalone || sessionStorage.getItem("pwa_dismissed")) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => {
      setVisible(false);
      setDeferred(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    sessionStorage.setItem("pwa_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 left-4 z-[60] flex items-center gap-3 rounded-2xl border border-[color:var(--ink-hairline)] bg-[color:var(--paper)] px-4 py-3 shadow-lg"
      style={{ maxWidth: "min(92vw, 340px)" }}
    >
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[color:var(--evergreen-soft)] text-[color:var(--evergreen)]">
        <Download size={18} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-[color:var(--ink)]">Install HK Forexedge</p>
        <p className="text-xs text-[color:var(--ink-body)]">Add the app to your device for one-tap access.</p>
      </div>
      <button onClick={install} data-testid="pwa-install-btn" className="btn-edge shrink-0 text-xs">
        Install
      </button>
      <button onClick={dismiss} data-testid="pwa-install-dismiss" aria-label="Dismiss"
        className="shrink-0 rounded-full p-1 text-[color:var(--ink-muted)] hover:text-[color:var(--ink)]">
        <X size={16} />
      </button>
    </div>
  );
}
